import * as Enum from './enum';

import { Helper } from '../common/helpers/helper';
import { DashboardConfiguration } from './';
import { IExportToChildApplication } from './IExportToChildApplication';

export class Dashboard implements IExportToChildApplication {
    backgroundUrl?: string;
    categories: string[];
    col: number;
    configuration: DashboardConfiguration;
    dashboardLink: string;
    defaultPeriod: Enum.DashboardPeriod;
    documentation?: string;
    groupGuids: string[];
    groupTypes: string[];
    guid: string;
    id: string;
    isAutoRefresh: boolean;
    isDatePickerDisabled: boolean;
    isExportToChildApplication?: boolean;
    isHomePage: boolean;
    isTitleHidden?: boolean;
    longComment?: string;
    name: string;
    referenceGroup: string;
    row: number;
    shortComment?: string;
    sortOrder: number;
    url: string;

    constructor() {
        this.categories = [];
        this.configuration = new DashboardConfiguration();
        this.groupGuids = this.groupGuids || [];
        this.groupTypes = [];
        this.guid = Helper.getGuid();
    }

    serialize(): any {
        const self = this;
        const result: any = {
            backgroundUrl: self.backgroundUrl,
            categories: self.categories,
            col: self.col,
            configuration: DashboardConfiguration.serialize(this.configuration),
            defaultPeriod: self.defaultPeriod,
            groupGuids: self.groupGuids ? self.groupGuids.map(d => d) : [],
            groupTypes: self.groupTypes,
            guid: self.guid,
            id: self.id,
            isAutoRefresh: self.isAutoRefresh,
            isDatePickerDisabled: self.isDatePickerDisabled,
            isExportToChildApplication: self.isExportToChildApplication,
            isHomePage: self.isHomePage,
            name: self.name,
            referenceGroup: self.referenceGroup,
            row: self.row,
            shortComment: self.shortComment,
            sortOrder: self.sortOrder,
            url: self.url
        };
        return result;
    }

    static cloneWithoutConfiguration(objectToClone: Dashboard): Dashboard {
        const newDashboard: Dashboard = new Dashboard();
        newDashboard.backgroundUrl = objectToClone.backgroundUrl;
        newDashboard.categories = [].concat(objectToClone.categories);
        newDashboard.col = objectToClone.col;
        newDashboard.dashboardLink = objectToClone.dashboardLink;
        newDashboard.defaultPeriod = objectToClone.defaultPeriod;
        newDashboard.groupGuids = objectToClone.groupGuids ? objectToClone.groupGuids.map(d => d) : [];
        newDashboard.groupTypes = [].concat(objectToClone.groupTypes);
        newDashboard.guid = objectToClone.guid;
        newDashboard.id = objectToClone.id;
        newDashboard.isAutoRefresh = objectToClone.isAutoRefresh;
        newDashboard.isDatePickerDisabled = objectToClone.isDatePickerDisabled;
        newDashboard.isExportToChildApplication = objectToClone.isExportToChildApplication;
        newDashboard.isHomePage = objectToClone.isHomePage;
        newDashboard.isTitleHidden = objectToClone.isTitleHidden;
        newDashboard.name = objectToClone.name;
        newDashboard.referenceGroup = objectToClone.referenceGroup;
        newDashboard.row = objectToClone.row;
        newDashboard.shortComment = objectToClone.shortComment;
        newDashboard.sortOrder = objectToClone.sortOrder;
        newDashboard.url = objectToClone.url;
        return newDashboard;
    }
}